import { ResourceOptions } from 'react-admin';
import { FaDice } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxBlindBoxProbability;
export const icon = FaDice;
export const options: ResourceOptions = {
  label: 'module.blindBox.blindBoxProbability',
};
